export function publicApiBase() {
  const base =
    typeof window !== "undefined"
      ? window.env?.REACT_APP_API_URL
      : process.env.API_URL;
  return `${base ?? ""}/api/v1`;
}

export class BookTourError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "BookTourError";
    this.status = status;
  }
}

async function readError(res, fallback) {
  const header = res.headers.get("x-error-message");
  if (header) return header;
  const text = await res.text().catch(() => "");
  if (!text) return fallback;
  try {
    const data = JSON.parse(text);
    const candidates = [data?.error?.message, data?.error, data?.message];
    const message = candidates.find((v) => typeof v === "string" && v.trim());
    return message ?? fallback;
  } catch {
    return text.length < 200 ? text : fallback;
  }
}

/**
 * @param {string} token
 * @param {string} dateStr YYYY-MM-DD in the gym's timezone
 * @param {AbortSignal} [signal]
 */
export async function fetchTourSlots(token, dateStr, signal) {
  const url = `${publicApiBase()}/public/tour/${encodeURIComponent(token)}/slots?date=${encodeURIComponent(dateStr)}`;
  const res = await fetch(url, {
    signal,
    headers: { Accept: "application/json" },
  });
  if (!res.ok) {
    throw new BookTourError(
      await readError(res, "Could not load available times"),
      res.status
    );
  }
  return res.json();
}

/**
 * @param {string} token
 * @param {object} payload { start_datetime, end_datetime, name, email, phone, captcha_token }
 */
export async function createTourBooking(token, payload) {
  const url = `${publicApiBase()}/public/tour/${encodeURIComponent(token)}/bookings`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new BookTourError(
      await readError(res, "Could not complete your booking"),
      res.status
    );
  }
  return res.json();
}
